export default __webpack_public_path__ + "static/media/multirotor-aircraft.e5268ee3.jpg";